export default "__VITE_ASSET__DEiHLGXy__"